import axios from "axios";
import notify from "devextreme/ui/notify";

export const instance = axios.create({
  timeout: 10000
});

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    const rest = error.response;
    if (rest && rest.data) {
      const errors = rest.data.errors;
      if (errors)
      {
        const message = errors
          .map(({ message }) => message)
          .join(", ");
        notify(
          {
            closeOnClick: true,
            closeOnOutsideClick: true,
            message
          },
          "error"
        );
      }
      else if (rest.data.status === 500){
        const message = "Ошибка сервера. При отправке запроса произошла ошибка.";
        notify(
          {
            closeOnClick: true,
            closeOnOutsideClick: true,
            message
          },
          "error"
        );
      }
      else {
        const message = "При отправке запроса произошла ошибка.";
        notify(
          {
            closeOnClick: true,
            closeOnOutsideClick: true,
            message
          },
          "error"
        );
      }
    }
    else {
      const message = "Время ожидания ответа с сервера истекло. Попробуйте перезагрузить страницу";
      notify(
        {
          closeOnClick: true,
          closeOnOutsideClick: true,
          message
        },
        "error"
      );
    }
    return Promise.reject(error);
  }
);
